import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  get_interview_kit_by_id_data_action,
  get_shortlisted_candidates_by_assignmentkit_action,
  create_shortlisting_candidate_by_hm_action,
  update_shortlisted_candidate_by_hm_data_action,
  hm_delete_shortlisted_candidate_by_id_action,
  get_shortlisted_candidates_by_hm_action,
} from "../../../redux/_actions";
import { showSuccessMessage } from "../../../_uiComponents/ShowMessageSnack";

function useShortListedCandidateAssessment() {
  const [loading, setLoading] = useState(false);
  const [loadingShortlisted, setLoadingShortlisted] = useState(false);
  const [interviewKitSkills, setInterviewKitSkills] = useState([]);
  const [interviewKit, setInterviewKit] = useState({});
  const [sharedShortlistCandidates, setSharedShortlistCandidates] = useState({});
  const [ShortlistCandidates, setShortlistCandidates] = useState({});
  const [completedCount, setCompletedCount] = useState(0);
  const [pageNum, setPageNum] = useState(1);
  const [nextPage, setNextPage] = useState(1);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();


  const { interviewKitData } = useSelector(
    (state) => state.get_interview_kit_by_id_data_reducer
  );

  const { shortlistedCandidateByAssessmentIdData } = useSelector(
    (state) => state.get_shortlisted_candidates_by_assignmentkit_reducer
  );


  useEffect(() => {
    const id = params?.id;

    if (id) {
      callInterviewKitApi(id);
      callShortListedCandidatesApi(id);
    }
  }, []);


  useEffect(() => {
    if (
      shortlistedCandidateByAssessmentIdData &&
      shortlistedCandidateByAssessmentIdData?.data
    ) {
      setSharedShortlistCandidates(
        shortlistedCandidateByAssessmentIdData &&
        shortlistedCandidateByAssessmentIdData?.data && shortlistedCandidateByAssessmentIdData.data?.results
      );
    }
  }, [shortlistedCandidateByAssessmentIdData]);


  useEffect(() => {
    if (interviewKitData?.data) {
      let allSkills = [];
      const data = interviewKitData?.data;

      data?.topics &&
        Array.isArray(data.topics) &&
        data.topics.forEach(
          (element) =>
            element?.questions &&
            element.questions.forEach((skill) => {
              if (allSkills.indexOf(skill.skill_names[0]) === -1) {
                allSkills.push(skill.skill_names[0]);
              }
            })
        );
      setInterviewKitSkills(allSkills);
      setInterviewKit(interviewKitData?.data);
    }
  }, [interviewKitData]);


  const callInterviewKitApi = async (id) => {
    setLoading(true);
    await dispatch(get_interview_kit_by_id_data_action(id));
    setLoading(false);
  };

  // const countCompletedCandidates = () => {
  //   let count = 0;

  //   submittedCandidatesInterviewList.forEach((item) => {
  //     if (item?.remaining_ques_count === 0) {
  //       count += 1;
  //     }
  //   });

  //   return count;
  // };

  const onViewAssessmentClick = (applicantId) => {
    navigate(
      `/view-assessment-video?interviewKit=${interviewKit?.id}&applicant=${applicantId}`
    );
  };

  const onBackClick = () => {
    navigate(-1);
  };

  const editAssessmentKit = (id) => {
    navigate(`/create-assessment/${id}`);
  };

  const onPublicProfileClick = (item) => {
    if (
      item?.details &&
      item.details?.candidate_details &&
      item.details.candidate_details?.user_details &&
      item.details.candidate_details.user_details?.hash_id
    ) {
      navigate(
        `/view-candidate-profile/${item.details.candidate_details.user_details?.hash_id}`
      );
    }
    if (
      item?.details &&
      item.details?.candidate_detail &&
      item.details.candidate_detail?.hash_id
    ) {
      navigate(
        `/view-candidate-profile/${item.details.candidate_detail?.hash_id}`
      );
    }
    if (
      item &&
      item.short_listed_candidate_details &&
      item.short_listed_candidate_details?.hash_id
    ) {
      navigate(
        `/view-candidate-profile/${item &&
        item.short_listed_candidate_details &&
        item.short_listed_candidate_details?.hash_id
        }`
      );
    }

    if (
      item &&
      item?.details?.candidate_details &&
      item?.details?.candidate_details?.hash_id
    ) {
      navigate(
        `/view-candidate-profile/${item &&
        item?.details?.candidate_details &&
        item?.details?.candidate_details?.hash_id
        }`
      );
    }
  };
  const onShareAssessmentClick = (item) => {
    const isDev =
      !process.env.NODE_ENV || process.env.NODE_ENV === "development";
    const url = isDev
      ? `http://localhost:3000/view-assessment-video?interviewKit=${interviewKit?.id}&candidate=${item.details?.candidate}
`
      : `${process.env.REACT_APP_DEV_ROOT_URL}/view-assessment-video?interviewKit=${interviewKit?.id}&candidate=${item.details?.candidate}
`;
    window.navigator.clipboard.writeText(url);
    showSuccessMessage(`Share Assessment Url Copied ${url}`);
  };

  const onNextPageClick = () => {
    setPageNum((page) => page + 1);
  };

  const callShortListedCandidatesApi = async (id) => {
    setLoading(true);
    await dispatch(get_shortlisted_candidates_by_assignmentkit_action(id));
    setLoading(false);
  };

  const onClickShortlist = async (candidateBucketListId) => {
    const id = params?.id
    const data = {
      bucket_list_candidate: candidateBucketListId,
      is_favourite: true
    };
    await dispatch(create_shortlisting_candidate_by_hm_action(data));
  };

  const onClickUnShortlist = async (id) => {
    await dispatch(hm_delete_shortlisted_candidate_by_id_action(id));
    const kitId = params?.id;
    if (kitId) {
      const data = {
        is_favourite: false
      };
      await dispatch(update_shortlisted_candidate_by_hm_data_action(data, id));
    }
    };

    const ontabSelection = async () => {
      const id = params?.id;
      if (id) {
        await dispatch(get_shortlisted_candidates_by_assignmentkit_action(id));
      }
    };
    return {
      loading,
      interviewKit,
      interviewKitSkills,
      nextPage,
      sharedShortlistCandidates,
      // countCompletedCandidates,  
      onViewAssessmentClick,
      onBackClick,
      editAssessmentKit,
      onPublicProfileClick,
      onShareAssessmentClick,
      onNextPageClick,
      onClickShortlist,
      onClickUnShortlist,
      ontabSelection,
    };
  }

  export default useShortListedCandidateAssessment;
